import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import { getProjectById } from './getProjectById.api';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function addNewUser(
	firstName,
	lastName,
	email,
	phoneNumber,
	projectsList
) {
	try {
		var projectListKeys = Object.keys(projectsList);

		var projectListObj = {};

		projectListKeys.forEach((key) => {
			var projectDetails = projectsList[key];

			projectListObj = {
				...projectListObj,
				[projectDetails.key]: projectDetails.role,
			};
		});

		console.log('projectListObj', projectListObj);

		const randomPassword = Math.random().toString(36).slice(2);

		let creatUserAccount = firebase
			.functions()
			.httpsCallable('createUserAccountWithEmailAddPassword');
		let currentUserId = await creatUserAccount({
			email: email,
			password: randomPassword,
			displayName: firstName + ' ' + lastName,
		});

		let user = firebase.database().ref('/users/' + currentUserId.data);
		await user.set({
			email: email,
			phoneNumber: phoneNumber,
			fullName: firstName + ' ' + lastName,
			displayName: firstName + ' ' + lastName,
			avatarCode: 'undefined',
			initialPassword: randomPassword,
			projectRoles: projectListObj,
			archived: false,
			createdAt: new Date().getTime(),
		});

		if (projectListObj[projectCode] === 'cobroker') {
			let coBrokerRef = firebaseRef.ref(
				'/kavtek_coBrokers/' + projectCode
			);
			let newCoBrokerRef = await coBrokerRef.push();
			await newCoBrokerRef.set({
				id: '',
				email: email,
				phoneNumber: phoneNumber,
				address: '',
				commissionPercentage: 0,
				numberOfLotsAllowed: 1,
				salesAgency: '',
				userId: currentUserId.data,
			});
		}
	} catch (error) {
		throw error;
	}
}
